var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSslCertificate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.967,
    height: 31.429,
    viewBox: "0 0 24.967 31.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Elipse_293",
    "data-name": "Elipse 293",
    d: "M7.064,0a7.065,7.065,0,0,1,2.75,13.572A7.065,7.065,0,0,1,4.314.555,7.02,7.02,0,0,1,7.064,0Zm0,12.991A5.928,5.928,0,1,0,1.136,7.064,5.934,5.934,0,0,0,7.064,12.991Z",
    transform: "translate(4.617 21.872) rotate(-83.05)",
    fill: "#0ec14a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_903",
    "data-name": "Caminho 903",
    d: "M103.363,78.417a.568.568,0,0,1-.4-.166l-2.535-2.535a.568.568,0,0,1,.8-.8l2.133,2.133L107.1,73.3a.568.568,0,0,1,.8.8l-4.144,4.144A.568.568,0,0,1,103.363,78.417Z",
    transform: "translate(-91.464 -60.021)",
    fill: "#0ec14a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_904",
    "data-name": "Caminho 904",
    d: "M89.517,38.5a.567.567,0,0,1,.348.119h0A32.469,32.469,0,0,0,93.731,41.1a17.027,17.027,0,0,0,7.7,2.441.568.568,0,0,1,.568.568V56.881a8.432,8.432,0,0,1-3.137,6.846c-1.8,1.329-6.839,4.662-7.832,5.316l-1.2.793a.568.568,0,0,1-.625,0L88,69.043c-.992-.655-6.033-3.988-7.831-5.316a8.432,8.432,0,0,1-3.137-6.846V44.107a.568.568,0,0,1,.568-.568,17.046,17.046,0,0,0,7.717-2.45,32.35,32.35,0,0,0,3.85-2.47A.567.567,0,0,1,89.517,38.5Zm11.348,6.158a14.231,14.231,0,0,1-3.765-.8,25.747,25.747,0,0,1-3.93-1.771,34.544,34.544,0,0,1-3.653-2.309,34.542,34.542,0,0,1-3.653,2.309,25.748,25.748,0,0,1-3.93,1.771,14.231,14.231,0,0,1-3.765.8V56.881a7.3,7.3,0,0,0,2.676,5.932c1.813,1.339,7.176,4.882,7.782,5.282l.89.587.89-.586c.606-.4,5.969-3.942,7.782-5.282a7.3,7.3,0,0,0,2.676-5.932Z",
    transform: "translate(-77.033 -38.5)",
    fill: "#0ec14a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSslCertificate);
export default __webpack_public_path__ + "static/media/sslCertificate.d92cc3113b590da284b90e1dbf750909.svg";
export { ForwardRef as ReactComponent };